export default __webpack_public_path__ + "static/media/253.2386b31b.jpg";